// Pluralisation française minimale (micro-complément 7b) — module 100 % PUR,
// ZÉRO dépendance (aucune lib i18n). Règle gravée : 0 et 1 = singulier,
// ≥ 2 = pluriel. Pluriel irrégulier passé explicitement (ex. créneau/créneaux).
export function pluriel(n: number, mot: string, motPluriel = `${mot}s`): string {
  return n >= 2 ? motPluriel : mot;
}
